(function () {
  'use strict';
  if (window.__swHeaderSearchAlias) return;
  window.__swHeaderSearchAlias = true;

  const states = new WeakMap();
  const selector = '[data-sw-header-search-suggestions]';

  function setup(panel) {
    const bar = panel.closest('.search-bar');
    if (!bar || states.has(bar)) return;
    const form = bar.querySelector('form.search-form');
    const input = form && form.querySelector('input[name="q"]');
    const link = panel.querySelector('[data-sw-header-search-alias]');
    if (!input || !link) return;
    const state = { dismissed: false, composing: false };

    function hide() { link.hidden = true; }
    function sync() {
      const type = form.querySelector('[name="type"]');
      const types = type ? type.value.split(',').map(value => value.trim()) : [];
      const allowsProducts = !type || !type.value.trim() || types.includes('product') || types.includes('all');
      if (bar.dataset.liveSearch !== 'true' || state.dismissed || state.composing || !bar.contains(document.activeElement) || !allowsProducts) {
        hide();
        return;
      }
      try {
        const api = window.SweetweetSearchIntent;
        const intent = api && typeof api.inspect === 'function' && api.inspect(input.value);
        const match = intent && intent.productSuggestion;
        link.hidden = !(match && String(match.productId) === link.dataset.productId);
      } catch (_) { hide(); }
    }

    states.set(bar, { dismiss: function () { state.dismissed = true; hide(); } });
    hide();
    ['input', 'search', 'change'].forEach(eventName => {
      form.addEventListener(eventName, function () { state.dismissed = false; sync(); });
    });
    input.addEventListener('compositionstart', function () { state.composing = true; hide(); });
    input.addEventListener('compositionend', function () { state.composing = false; state.dismissed = false; sync(); });
    bar.addEventListener('focusin', function (event) {
      if (!bar.contains(event.relatedTarget)) state.dismissed = false;
      sync();
    });
    bar.addEventListener('focusout', function () { window.setTimeout(sync, 0); });
    bar.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      state.dismissed = true;
      if (link.contains(document.activeElement)) input.focus();
      hide();
    });
    bar.addEventListener('click', function (event) {
      if (event.target.closest('.js-search-form-close')) {
        state.dismissed = true;
        hide();
      }
    });
    sync();
  }

  // Escape belongs to the focused, open search only; the drawer retains its own handler.
  let searchOpener = null;
  let escapeReleasePending = false;
  let escapeReleaseTimer = null;
  function visible(element) {
    return !!element && element.isConnected && !!element.getClientRects().length &&
      window.getComputedStyle(element).visibility !== 'hidden';
  }
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest && event.target.closest('.js-search-form-open');
    if (trigger && visible(trigger)) searchOpener = trigger;
  }, true);
  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.isComposing) return;
    if (escapeReleasePending && event.repeat) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const active = document.activeElement;
    const bar = active && active.closest && active.closest('.search-bar');
    if (!bar || bar.classList.contains('mobile-menu-search') || !visible(bar) ||
        !document.body.classList.contains('search-bar-open') || !bar.contains(event.target)) return;
    const close = bar.querySelector('.js-search-form-close');
    if (!visible(close) || close.disabled) return;
    const state = states.get(bar);
    if (state) state.dismiss();
    const section = bar.closest('.shopify-section');
    const opener = visible(searchOpener) && !bar.contains(searchOpener) && (!section || section.contains(searchOpener)) ? searchOpener :
      Array.from((section || document).querySelectorAll('.js-search-form-open')).find(element => visible(element) && !bar.contains(element));
    event.preventDefault();
    event.stopImmediatePropagation();
    escapeReleasePending = true;
    window.clearTimeout(escapeReleaseTimer);
    escapeReleaseTimer = window.setTimeout(function () { escapeReleasePending = false; }, 1000);
    close.click(); // Preserve native close behavior and native tab-order recalculation.
    window.requestAnimationFrame(function () {
      if (!document.body.classList.contains('search-bar-open') && visible(opener)) opener.focus();
    });
  }, true);
  window.addEventListener('keyup', function (event) {
    // Consume only the release paired with our handled Escape, never an unrelated shortcut.
    if (event.key !== 'Escape' || !escapeReleasePending) return;
    escapeReleasePending = false;
    window.clearTimeout(escapeReleaseTimer);
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  function boot() { document.querySelectorAll(selector).forEach(setup); }
  document.addEventListener('pointerdown', function (event) {
    document.querySelectorAll(selector).forEach(panel => {
      const bar = panel.closest('.search-bar');
      const state = states.get(bar);
      if (state && !bar.contains(event.target)) state.dismiss();
    });
  });
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
